// extracted by mini-css-extract-plugin
export var changeIcon = "_60-4";
export var container = "_60-0";
export var divider = "_60-7";
export var externalLinkIcon = "_60-1";
export var green = "_60-5";
export var helpCircleIcon = "_60-3";
export var iconButton = "_60-2";
export var red = "_60-6";